var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: {
        "max-width": "60%",
        heigth: "800px",
        bus: _vm.busModal,
        persistent: ""
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("v-spacer"),
              _c(
                "BaseButton",
                {
                  attrs: { underlined: "" },
                  on: {
                    click: function($event) {
                      return _vm.sendToFaq(close)
                    }
                  }
                },
                [_vm._v(" Quero saber mais ")]
              ),
              _c(
                "BaseButton",
                { attrs: { primary: "" }, on: { click: close } },
                [_vm._v(" Ok ")]
              ),
              _c("v-spacer")
            ]
          }
        }
      ])
    },
    [
      _c("Title", {
        attrs: { title: "Boas vindas", subtitle: "Primeiros passos" }
      }),
      _c(
        "div",
        [
          _c(
            "div",
            {
              staticClass: "text-center",
              staticStyle: {
                "margin-bottom": "20px",
                "align-items": "center",
                "justify-content": "center"
              }
            },
            [
              _c(
                "p",
                {
                  staticClass: "text-bold",
                  staticStyle: { "margin-bottom": "20px" }
                },
                [_vm._v(_vm._s(_vm.negritosTour[_vm.stepTour - 1]))]
              ),
              _c("p", { staticClass: "text-secondary" }, [
                _vm._v(" " + _vm._s(_vm.textosTour[_vm.stepTour - 1]) + " ")
              ])
            ]
          ),
          _c("v-img", {
            staticClass: "p-0 border",
            attrs: {
              src: _vm.imagensTour[_vm.stepTour - 1],
              "lazy-src": _vm.imagensTour[_vm.stepTour - 1],
              "aspect-ratio": "1",
              contain: "",
              height: "300"
            },
            scopedSlots: _vm._u([
              {
                key: "placeholder",
                fn: function() {
                  return [
                    _c(
                      "v-row",
                      {
                        staticClass: "fill-height ma-0",
                        attrs: { align: "center", justify: "center" }
                      },
                      [
                        _c("v-progress-circular", {
                          attrs: { indeterminate: "", color: "grey lighten-5" }
                        })
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "text-center", staticStyle: { margin: "20px" } },
        [
          _c("v-pagination", {
            attrs: { length: _vm.imagensTour.length },
            model: {
              value: _vm.stepTour,
              callback: function($$v) {
                _vm.stepTour = $$v
              },
              expression: "stepTour"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }